interface LoginModel {
  userName: string;
  password: string;
}

interface LoginResponse {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  isPasswordExpired: boolean;
  token: string;
  refreshToken: string;
  refreshTokenExpiration: Date;
  clientLogoId: string;
}

interface LoginTermsConditionsResponse {
  id: string;
  content: string;
  version: number;
  createdAt: Date;
}

enum ClaimType {
  Role = "http://schemas.microsoft.com/ws/2008/06/identity/claims/role",
}

enum RolesTypes {
  SuperAdmin = "SuperAdministrator",
  Client = "ClientAdministrator",
  POSUser = "PosUser",
}

enum LoggedUserStatus {
  NotVerified,
  RegistrationNotComplete,
  RequestSubmited,
  PendingApproval,
  RequestRejected,
  OfferzMember,
}
export { ClaimType, RolesTypes, LoggedUserStatus };
export type { LoginModel, LoginResponse, LoginTermsConditionsResponse };
